import React, { FC, ReactElement } from 'react';
import { withStyles } from '@mui/styles';
// Components
import PinPanelComponent from './pinPanelComponent';
// Resources
import { PinProps } from './mapTypes';
import SvgIcon from '../icons/SvgIcon';
// Style
import styles from './pin-style';
import { IconAxel } from '../../resources/images';
import { dropOffGreen } from '../../resources/style/colors';

const DropOffPinComponent: FC<PinProps> = ({ lat, lng, classes, drawed, ...rest }): ReactElement => {
    return (
        <div id="to">
            <SvgIcon icon={IconAxel.DropOffPin} className={classes.pinPos} size="inherit" stroke={dropOffGreen} />
            <PinPanelComponent mode="to" {...rest} classes={classes} drawed={drawed} />
        </div>
    );
};

export default withStyles(styles)(DropOffPinComponent);
